export default __webpack_public_path__ + "static/media/DNo.9-1.af24922e.jpg";